module.exports = __webpack_public_path__ + "img/img_9.d7e81220.png";